var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"option",staticClass:"select-option text-gray-900 group flex w-full items-center rounded-md px-2 py-2 text-sm cursor-pointer hover:bg-gray-100",on:{"!click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }